/**
 * Custom Availability Widget
 * Replaces the Multi-Location Inventory app widget with a custom implementation
 * that shows inventory based on selected shipping method and location
 */

try {
  console.log('[Custom Availability Widget] Script file loaded and executing...');
} catch(e) {
  console.error('[Custom Availability Widget] Error in initial check:', e);
}

(function() {
  'use strict';
  
  try {
    console.log('[Custom Availability Widget] IIFE starting...');
  } catch(e) {
    console.error('[Custom Availability Widget] Error in IIFE start:', e);
  }

  // Location details mapping (from header-location-selector.js)
  var locationIdToDetails = {
    43460657288: { name: "Newberg Location (Critter Cabana)", address1: "516 E First St", city: "Newberg", province: "Oregon", zip: "97132", phone: "503-537-2570", lat: 45.3000451, lng: -122.9741523 },
    83963379929: { name: "Salem Pet Supply (North)", address1: "3185 Market St NE", city: "Salem", province: "Oregon", zip: "97301", phone: "503-990-7455", lat: 44.9511534, lng: -122.9964808 },
    83963445465: { name: "South Salem Pet Supply", address1: "4695 Commercial St SE", city: "Salem", province: "Oregon", zip: "97302", phone: "503-585-0553", lat: 44.8867386, lng: -123.0345652 },
    83963281625: { name: "Tigard Pet Supply", address1: "16200 SW Pacific Hwy Suite W-W2", city: "Tigard", province: "Oregon", zip: "97224", phone: "503-339-2426", lat: 45.4030263, lng: -122.7946112 },
    42639884424: { name: "Wilsonville Pet Supply", address1: "8406 SW Main St. #200", city: "Wilsonville", province: "Oregon", zip: "97070", phone: "503-682-9812", lat: 45.302142, lng: -122.763612 },
    85743730905: { name: "Gresham Pet Supply", address1: "1152 Northwest Civic Drive", city: "Gresham", province: "Oregon", zip: "97030", phone: "503-666-1518", lat: 45.505471, lng: -122.4408056 }
  };

  var widgetContainer = null;
  var currentVariantId = null;
  var inventoryData = null;
  var isInitialized = false;
  var isRendering = false; // Flag to prevent concurrent renders
  var renderDebounceTimer = null; // Debounce timer
  var lastRenderTime = 0; // Track last render time
  var RENDER_DEBOUNCE_MS = 1000; // Minimum time between renders (1000ms - increased)
  var lastRenderParams = null; // Track last render parameters to avoid duplicate renders
  var renderCallCount = 0; // Track render calls to detect loops
  var pageVariantId = null; // LOCKED variant ID for this page - prevents cross-product contamination
  
  /**
   * Calculate distance between two coordinates using Haversine formula
   * Returns distance in miles
   */
  function calculateDistance(lat1, lng1, lat2, lng2) {
    var R = 3959; // Earth's radius in miles
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLng = (lng2 - lng1) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLng / 2) * Math.sin(dLng / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }
  
  /**
   * Get user's delivery address coordinates
   */
  function getDeliveryCoordinates() {
    try {
      // Check localStorage for saved coordinates
      var savedCoords = localStorage.getItem('deliveryCoordinates');
      if (savedCoords) {
        var coords = JSON.parse(savedCoords);
        if (coords && coords.lat && coords.lng) {
          return { lat: parseFloat(coords.lat), lng: parseFloat(coords.lng) };
        }
      }
      
      // Check window object (set by header-location-selector)
      if (window.deliveryCoordinates && window.deliveryCoordinates.lat && window.deliveryCoordinates.lng) {
        return {
          lat: parseFloat(window.deliveryCoordinates.lat),
          lng: parseFloat(window.deliveryCoordinates.lng)
        };
      }
    } catch(e) {
      console.warn('[Custom Availability Widget] Error getting delivery coordinates:', e);
    }
    return null;
  }

  /**
   * Get current shipping method from state manager or localStorage
   */
  function getCurrentMethod() {
    // Check multiple sources for the current method (in order of reliability)
    
    // 1. Check window.currentMethod (set by header-location-selector.js)
    if (window.currentMethod) {
      return window.currentMethod;
    }
    
    // 2. Check StateManager
    if (window.StateManager && window.StateManager.currentMethod) {
      return window.StateManager.currentMethod;
    }
    
    // 3. Check active button's data-method attribute (most reliable UI state)
    var activeBtn = document.querySelector('.header-method-btn[data-active="true"], .header-method-btn.active, .mobile-method-btn[data-active="true"], .mobile-method-btn.active');
    if (activeBtn) {
      var method = activeBtn.getAttribute('data-method');
      if (method) {
        return method;
      }
    }
    
    // 4. Check if body has shipping mode class
    if (document.body.classList.contains('shipping-mode-local')) {
      return 'local_delivery'; // or 'pickup' - you may want to distinguish these
    }
    if (document.body.classList.contains('shipping-mode-shipping')) {
      return 'shipping';
    }
    
    // 5. Check localStorage
    var saved = localStorage.getItem('shippingMethod');
    if (saved) {
      return saved;
    }
    
    // Default to shipping
    return 'shipping';
  }

  /**
   * Get selected location ID
   * Priority: forcedLocationId > Header text matching > inventoryInfo API > StateManager > localStorage
   */
  function getSelectedLocationId() {
    // Check multiple sources for selected location ID
    
    // 1. Check forced location ID FIRST (set when location is selected but API call fails)
    // This is the most reliable source when user just selected a location
    if (window.forcedLocationId) {
      var forcedId = window.forcedLocationId;
      var parsedForcedId = typeof forcedId === 'number' ? forcedId : parseInt(forcedId, 10);
      if (!isNaN(parsedForcedId)) {
        console.log('[Custom Availability Widget] Got location ID from forcedLocationId (user just selected):', parsedForcedId);
        return parsedForcedId;
      }
    }
    
    // 2. Try to match location name from header text to location IDs
    // This is important when the API hasn't updated yet but the header shows the location
    try {
      var locationTextEl = document.querySelector('.location-picker-text, .location-picker-text-mobile');
      if (locationTextEl) {
        var locationName = locationTextEl.textContent.trim();
        console.log('[Custom Availability Widget] Checking header location text:', locationName);
        
        // Skip if it's "Online Warehouse" or similar (shipping mode)
        if (locationName && !locationName.match(/online|warehouse|shipping/i)) {
          // Try to find matching location in inventoryInfo
          if (window.inventoryInfo && window.inventoryInfo.locationSettings && window.inventoryInfo.locationSettings.details) {
            for (var i = 0; i < window.inventoryInfo.locationSettings.details.length; i++) {
              var loc = window.inventoryInfo.locationSettings.details[i];
              // Match by exact name or partial match (e.g., "Salem Pet Supply (North)" matches "North")
              if (loc.name && (loc.name.trim() === locationName || 
                  locationName.includes(loc.name.trim()) || 
                  loc.name.includes(locationName))) {
                var matchedId = typeof loc.id === 'number' ? loc.id : parseInt(loc.id, 10);
                if (!isNaN(matchedId)) {
                  console.log('[Custom Availability Widget] Matched location from header text:', locationName, '->', loc.name, 'ID:', matchedId);
                  return matchedId;
                }
              }
            }
          }
        }
      }
    } catch(e) {
      // Ignore errors
    }
    
    // 3. Try to get from Multi-Location App API (may be stale if user just changed location)
    if (window.inventoryInfo && window.inventoryInfo.api) {
      try {
        // Try getSelectedLocationId first (synchronous or async)
        if (window.inventoryInfo.api.getSelectedLocationId) {
          var locId = window.inventoryInfo.api.getSelectedLocationId();
          // Handle promise if it returns one
          if (locId && typeof locId.then === 'function') {
            // Can't wait for promise here, return null and let async update handle it
            return null;
          }
          if (locId !== null && locId !== undefined) {
            var id = typeof locId === 'number' ? locId : parseInt(locId, 10);
            if (!isNaN(id)) {
              console.log('[Custom Availability Widget] Got location ID from API getSelectedLocationId:', id);
              return id;
            }
          }
        }
        
        // Try getSelectedLocation (returns full location object, might be async)
        if (window.inventoryInfo.api.getSelectedLocation) {
          try {
            var locPromise = window.inventoryInfo.api.getSelectedLocation();
            if (locPromise && typeof locPromise.then === 'function') {
              // Async - can't wait here
              return null;
            } else if (locPromise && locPromise.id) {
              var id = typeof locPromise.id === 'number' ? locPromise.id : parseInt(locPromise.id, 10);
              if (!isNaN(id)) {
                console.log('[Custom Availability Widget] Got location ID from API getSelectedLocation:', id);
                return id;
              }
            }
          } catch(e) {
            // Ignore errors
          }
        }
      } catch(e) {
        // Ignore errors
      }
    }
    
    // 3. Try to match location name from header text to location IDs
    // This is important when the API hasn't updated yet but the header shows the location
    try {
      var locationTextEl = document.querySelector('.location-picker-text, .location-picker-text-mobile');
      if (locationTextEl) {
        var locationName = locationTextEl.textContent.trim();
        console.log('[Custom Availability Widget] Checking header location text:', locationName);
        
        // Skip if it's "Online Warehouse" or similar (shipping mode)
        if (locationName && !locationName.match(/online|warehouse|shipping/i)) {
          // Try to find matching location in inventoryInfo
          if (window.inventoryInfo && window.inventoryInfo.locationSettings && window.inventoryInfo.locationSettings.details) {
            for (var i = 0; i < window.inventoryInfo.locationSettings.details.length; i++) {
              var loc = window.inventoryInfo.locationSettings.details[i];
              // Match by exact name or partial match (e.g., "Salem Pet Supply (North)" matches "North")
              if (loc.name && (loc.name.trim() === locationName || 
                  locationName.includes(loc.name.trim()) || 
                  loc.name.includes(locationName))) {
                var matchedId = typeof loc.id === 'number' ? loc.id : parseInt(loc.id, 10);
                if (!isNaN(matchedId)) {
                  console.log('[Custom Availability Widget] Matched location from header text:', locationName, '->', loc.name, 'ID:', matchedId);
                  return matchedId;
                }
              }
            }
          }
        }
      }
    } catch(e) {
      // Ignore errors
    }
    
    // 3. Check StateManager (set by header location selector)
    if (window.StateManager && window.StateManager.selectedLocationId) {
      var stateId = window.StateManager.selectedLocationId;
      var parsedId = typeof stateId === 'number' ? stateId : parseInt(stateId, 10);
      if (!isNaN(parsedId)) {
        console.log('[Custom Availability Widget] Got location ID from StateManager:', parsedId);
        return parsedId;
      }
    }
    
    // 4. Check localStorage (fallback and for auto-selection)
    try {
      var saved = localStorage.getItem('selectedLocationId');
      if (saved) {
        var savedId = parseInt(saved, 10);
        if (!isNaN(savedId)) {
          console.log('[Custom Availability Widget] Got location ID from localStorage:', savedId);
          return savedId;
        }
      }
    } catch(e) {
      // Storage might be blocked
    }
    
    console.log('[Custom Availability Widget] No selected location ID found');
    return null;
  }
  
  /**
   * Auto-select the last selected location/method on page load
   */
  function autoSelectLastSelection() {
    try {
      // Get last selected method
      var lastMethod = localStorage.getItem('lastSelectedMethod');
      if (lastMethod && (lastMethod === 'local_delivery' || lastMethod === 'local_pickup')) {
        console.log('[Custom Availability Widget] Auto-selecting last method:', lastMethod);
        
        // Set the method
        if (window.StateManager && window.StateManager.setMethod) {
          window.StateManager.setMethod(lastMethod);
        }
        window.currentMethod = lastMethod;
        
        // Also save to the key that header-location-selector.js uses
        try {
          if (window.StorageManager && window.StorageManager.setLocalStorage) {
            window.StorageManager.setLocalStorage('shippingMethod', lastMethod);
          } else {
            localStorage.setItem('shippingMethod', lastMethod);
          }
        } catch(e) {
          // Storage might be blocked
        }
        
        // Update the header buttons to show the correct selected state
        setTimeout(function() {
          // Update desktop buttons
          var headerMethodSelector = document.querySelector('.header-method-selector');
          if (headerMethodSelector) {
            var buttons = headerMethodSelector.querySelectorAll('.header-method-btn');
            buttons.forEach(function(btn) {
              var isActive = btn.getAttribute('data-method') === lastMethod;
              if (isActive) {
                btn.style.borderColor = '#298029';
                btn.style.backgroundColor = '#f0f8f0';
                btn.style.color = '#298029';
                btn.style.fontWeight = '500';
                btn.setAttribute('data-active', 'true');
                btn.classList.add('active');
              } else {
                btn.style.borderColor = '#d0d0d0';
                btn.style.backgroundColor = '#ffffff';
                btn.style.color = '#293149';
                btn.style.fontWeight = '400';
                btn.removeAttribute('data-active');
                btn.classList.remove('active');
              }
            });
          }
          
          // Update mobile buttons
          var mobileSelector = document.querySelector('.mobile-method-selector');
          if (mobileSelector) {
            var mobileButtons = mobileSelector.querySelectorAll('.mobile-method-btn');
            mobileButtons.forEach(function(btn) {
              var isActive = btn.getAttribute('data-method') === lastMethod;
              if (isActive) {
                btn.style.borderColor = '#298029';
                btn.style.backgroundColor = '#f0f8f0';
                btn.style.color = '#298029';
                btn.style.fontWeight = '500';
                btn.setAttribute('data-active', 'true');
                btn.classList.add('active');
              } else {
                btn.style.borderColor = '#d0d0d0';
                btn.style.backgroundColor = '#ffffff';
                btn.style.color = '#293149';
                btn.style.fontWeight = '400';
                btn.removeAttribute('data-active');
                btn.classList.remove('active');
              }
            });
          }
          
          // Also call updateActiveButton if it exists
          if (typeof updateActiveButton === 'function') {
            updateActiveButton();
          }
        }, 100);
        
        // Get last selected location ID
        var lastLocationId = localStorage.getItem('lastSelectedLocationId');
        if (lastLocationId) {
          var locId = parseInt(lastLocationId, 10);
          if (!isNaN(locId) && window.inventoryInfo && window.inventoryInfo.api && window.inventoryInfo.api.selectLocation) {
            console.log('[Custom Availability Widget] Auto-selecting last location:', locId);
            // Select the location via API
            window.inventoryInfo.api.selectLocation(locId).then(function() {
              console.log('[Custom Availability Widget] Successfully auto-selected location:', locId);
              // Trigger widget update
              setTimeout(function() {
                if (window.customAvailabilityWidget && typeof window.customAvailabilityWidget.render === 'function') {
                  window.customAvailabilityWidget.render();
                }
              }, 300);
            }).catch(function(err) {
              console.warn('[Custom Availability Widget] Failed to auto-select location:', err);
            });
          }
        }
      } else if (lastMethod === 'shipping') {
        // For shipping, just set the method
        if (window.StateManager && window.StateManager.setMethod) {
          window.StateManager.setMethod('shipping');
        }
        window.currentMethod = 'shipping';
        
        // Update the header buttons
        setTimeout(function() {
          var headerMethodSelector = document.querySelector('.header-method-selector');
          if (headerMethodSelector) {
            var buttons = headerMethodSelector.querySelectorAll('.header-method-btn');
            buttons.forEach(function(btn) {
              var isActive = btn.getAttribute('data-method') === 'shipping';
              if (isActive) {
                btn.style.borderColor = '#298029';
                btn.style.backgroundColor = '#f0f8f0';
                btn.style.color = '#298029';
                btn.style.fontWeight = '500';
                btn.setAttribute('data-active', 'true');
                btn.classList.add('active');
              } else {
                btn.style.borderColor = '#d0d0d0';
                btn.style.backgroundColor = '#ffffff';
                btn.style.color = '#293149';
                btn.style.fontWeight = '400';
                btn.removeAttribute('data-active');
                btn.classList.remove('active');
              }
            });
          }
          
          var mobileSelector = document.querySelector('.mobile-method-selector');
          if (mobileSelector) {
            var mobileButtons = mobileSelector.querySelectorAll('.mobile-method-btn');
            mobileButtons.forEach(function(btn) {
              var isActive = btn.getAttribute('data-method') === 'shipping';
              if (isActive) {
                btn.style.borderColor = '#298029';
                btn.style.backgroundColor = '#f0f8f0';
                btn.style.color = '#298029';
                btn.style.fontWeight = '500';
                btn.setAttribute('data-active', 'true');
                btn.classList.add('active');
              } else {
                btn.style.borderColor = '#d0d0d0';
                btn.style.backgroundColor = '#ffffff';
                btn.style.color = '#293149';
                btn.style.fontWeight = '400';
                btn.removeAttribute('data-active');
                btn.classList.remove('active');
              }
            });
          }
          
          if (typeof updateActiveButton === 'function') {
            updateActiveButton();
          }
        }, 100);
      }
    } catch(e) {
      console.warn('[Custom Availability Widget] Error in autoSelectLastSelection:', e);
    }
  }
  
  /**
   * Save the current selection to localStorage for auto-selection next time
   */
  function saveCurrentSelection() {
    try {
      var currentMethod = window.currentMethod || 'shipping';
      localStorage.setItem('lastSelectedMethod', currentMethod);
      
      // Also save to the key that header-location-selector.js uses
      try {
        if (window.StorageManager && window.StorageManager.setLocalStorage) {
          window.StorageManager.setLocalStorage('shippingMethod', currentMethod);
        } else {
          localStorage.setItem('shippingMethod', currentMethod);
        }
      } catch(e) {
        // Storage might be blocked
      }
      
      var selectedLocationId = getSelectedLocationId();
      if (selectedLocationId) {
        localStorage.setItem('lastSelectedLocationId', selectedLocationId.toString());
        console.log('[Custom Availability Widget] Saved selection - Method:', currentMethod, 'Location:', selectedLocationId);
      }
    } catch(e) {
      // Storage might be blocked
    }
  }

  /**
   * Get current variant ID from the page
   */
  function getCurrentVariantId() {
    // If we already locked a variant for this page, always return it
    // This prevents cross-product contamination when header-location-selector reinitializes
    if (pageVariantId) {
      return pageVariantId;
    }
    
    // Try multiple methods to get variant ID
    var variantId = null;
    
    // Method 1: Check for variant selector
    var variantSelect = document.querySelector('[name="id"], select[name*="variant"], input[name="id"][type="hidden"]');
    if (variantSelect) {
      variantId = variantSelect.value;
    }
    
    // Method 2: Check for data attributes
    if (!variantId) {
      var productForm = document.querySelector('form[action*="/cart/add"]');
      if (productForm) {
        var hiddenInput = productForm.querySelector('input[name="id"][type="hidden"]');
        if (hiddenInput) {
          variantId = hiddenInput.value;
        }
      }
    }
    
    // Method 3: Check URL parameters
    if (!variantId && window.location.search) {
      var params = new URLSearchParams(window.location.search);
      variantId = params.get('variant');
    }
    
    // Method 4: Check Shopify global meta analytics (critical fallback when product form is hidden due to sold-out status)
    if (!variantId && window.meta && window.meta.product && window.meta.product.variants && window.meta.product.variants[0]) {
      variantId = window.meta.product.variants[0].id;
    }
    
    // Method 5: Check ShopifyAnalytics global meta
    if (!variantId && window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.variants && window.ShopifyAnalytics.meta.product.variants[0]) {
      variantId = window.ShopifyAnalytics.meta.product.variants[0].id;
    }
    
    var result = variantId ? parseInt(variantId, 10) : null;
    
    // Lock this variant for the lifetime of the page
    if (result) {
      pageVariantId = result;
      console.log('[Custom Availability Widget] Locked page variant ID:', pageVariantId);
    }
    
    return result;
  }

  /**
   * Fetch inventory data for a variant from Shopify API
   */
  function fetchVariantInventory(variantId) {
    if (!variantId) {
      console.warn('[Custom Availability Widget] No variant ID provided');
      return Promise.resolve(null);
    }

    return fetch('/variants/' + variantId + '.js')
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Failed to fetch variant: ' + response.status);
        }
        return response.json();
      })
      .then(function(variant) {
        console.log('[Custom Availability Widget] Variant data:', variant);
        
        // Extract inventory information
        var inventory = {
          variantId: variant.id,
          available: variant.available,
          inventoryQuantity: variant.inventory_quantity || 0,
          inventoryManagement: variant.inventory_management,
          inventoryPolicy: variant.inventory_policy,
          inventoryItemId: variant.inventory_item_id // This is the key to getting per-location inventory
        };
        
        console.log('[Custom Availability Widget] Extracted inventory:', inventory);
        console.log('[Custom Availability Widget] Inventory Item ID:', inventory.inventoryItemId);
        
        // If we have inventory_item_id, try to fetch per-location inventory levels
        if (inventory.inventoryItemId) {
          // Note: This requires Admin API access, which frontend doesn't have
          // But we can try using the product JSON endpoint which might include location data
          // Or use the Multi-Location App's data if available
          console.log('[Custom Availability Widget] Found inventory_item_id, but cannot fetch inventory_levels from frontend (requires Admin API)');
        }
        
        return inventory;
      })
      .catch(function(error) {
        console.error('[Custom Availability Widget] Error fetching variant inventory:', error);
        return null;
      });
  }
  
  /**
   * Fetch inventory levels for all locations using Shopify's product JSON endpoint
   * This endpoint may include location-specific inventory if available
   */
  function fetchProductInventoryLevels(productId, variantId) {
    if (!productId) {
      console.warn('[Custom Availability Widget] No product ID provided');
      return Promise.resolve([]);
    }
    
    console.log('[Custom Availability Widget] Fetching product inventory levels for product:', productId);
    
    return fetch('/products/' + productId + '.js')
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Failed to fetch product: ' + response.status);
        }
        return response.json();
      })
      .then(function(product) {
        console.log('[Custom Availability Widget] Product data:', product);
        
        // Find the variant we're looking for
        var variant = product.variants.find(function(v) {
          return v.id === variantId;
        });
        
        if (!variant) {
          console.warn('[Custom Availability Widget] Variant not found in product');
          return [];
        }
        
        console.log('[Custom Availability Widget] Variant from product:', variant);
        console.log('[Custom Availability Widget] Variant inventory_item_id:', variant.inventory_item_id);
        
        // The product JSON endpoint doesn't include per-location inventory levels
        // We need to use a different approach - either:
        // 1. Use the Multi-Location App's API (if available)
        // 2. Extract from the app's widget DOM
        // 3. Use Shopify's Storefront API GraphQL (requires authentication)
        
        return [];
      })
      .catch(function(error) {
        console.error('[Custom Availability Widget] Error fetching product inventory levels:', error);
        return [];
      });
  }
  
  /**
   * Fetch inventory levels from backend proxy endpoint
   * This endpoint uses Admin API to get per-location inventory
   */
  function fetchInventoryLevelsFromBackend(variantId) {
    console.log('[Custom Availability Widget] Attempting to fetch inventory levels from backend for variant:', variantId);
    
    // Try multiple backend URL options
    // Option 1: Shopify app proxy (if configured) - add timestamp cache-buster to prevent Shopify CDN caching
    var appProxyUrl = '/apps/inventory/inventory-levels?variant_id=' + variantId + '&t=' + Date.now();
    
    // Option 2: Direct API path (if backend is on same domain) - add timestamp cache-buster
    var directApiUrl = '/api/inventory-levels?variant_id=' + variantId + '&t=' + Date.now();
    
    // Option 3: Full URL to Flask backend (update this with your actual backend URL)
    // TODO: Replace with your actual Flask backend URL
    // Examples:
    // - If Flask is on fiji server: 'http://fiji:8000/api/inventory-levels?variant_id=' + variantId
    // - If Flask is publicly accessible: 'https://your-domain.com/api/inventory-levels?variant_id=' + variantId
    // - If using ngrok or similar: 'https://your-ngrok-url.ngrok.io/api/inventory-levels?variant_id=' + variantId
    var backendBaseUrl = window.BACKEND_API_URL || ''; // Can be set via script tag or global variable
    // Also check for common variable names
    if (!backendBaseUrl && window.backendApiUrl) {
      backendBaseUrl = window.backendApiUrl;
    }
    if (!backendBaseUrl && typeof BACKEND_API_URL !== 'undefined') {
      backendBaseUrl = BACKEND_API_URL;
    }
    // Default fallback to api.cascadepetsupply.com if not set
    if (!backendBaseUrl) {
      backendBaseUrl = 'https://api.cascadepetsupply.com';
      console.log('[Custom Availability Widget] window.BACKEND_API_URL not set, using default:', backendBaseUrl);
    }
    var fullBackendUrl = backendBaseUrl ? (backendBaseUrl + '/api/inventory-levels?variant_id=' + variantId + '&t=' + Date.now()) : null;
    
    console.log('[Custom Availability Widget] Backend URLs - appProxy:', appProxyUrl, 'direct:', directApiUrl, 'full:', fullBackendUrl);
    console.log('[Custom Availability Widget] window.BACKEND_API_URL:', window.BACKEND_API_URL);
    
    // If we have a full backend URL, try it FIRST (most reliable, bypasses app proxy issues)
    if (fullBackendUrl) {
      console.log('[Custom Availability Widget] Trying full backend URL first:', fullBackendUrl);
      return fetch(fullBackendUrl)
        .then(function(response) {
          if (response.ok) {
            console.log('[Custom Availability Widget] ✓✓✓ SUCCESS: Got inventory from full backend URL');
            return response.json();
          }
          console.log('[Custom Availability Widget] Full backend URL failed (' + response.status + '), trying app proxy as fallback...');
          // Fall through to try app proxy
          return fetch(appProxyUrl);
        })
        .catch(function(error) {
          console.log('[Custom Availability Widget] Full backend URL error:', error.message, '- trying app proxy as fallback...');
          return fetch(appProxyUrl);
        });
    }
    
    // Try app proxy first (if no full URL available), but if it fails (404 or 500), immediately try direct API
    return fetch(appProxyUrl)
      .then(function(response) {
        if (response.ok) {
          console.log('[Custom Availability Widget] Got inventory from app proxy');
          return response.json();
        }
        // If app proxy returns 404 or 500, try direct API path
        if (response.status === 404 || response.status === 500) {
          console.log('[Custom Availability Widget] App proxy failed (' + response.status + '), trying direct API path...');
          return fetch(directApiUrl);
        }
        throw new Error('App proxy returned: ' + response.status);
      })
      .then(function(response) {
        // Handle response from direct API or continue from app proxy
        if (response && typeof response.json === 'function') {
          // This is a Response object, need to parse JSON
          if (!response.ok) {
            if (response.status === 404) {
              console.log('[Custom Availability Widget] Direct API path not found (404)');
              // Try full backend URL if available
              if (fullBackendUrl) {
                console.log('[Custom Availability Widget] Trying full backend URL:', fullBackendUrl);
                return fetch(fullBackendUrl)
                  .then(function(r) {
                    if (!r.ok) {
                      console.log('[Custom Availability Widget] Full backend URL failed:', r.status);
                      return null;
                    }
                    return r.json();
                  })
                  .catch(function(e) {
                    console.log('[Custom Availability Widget] Full backend URL error:', e.message);
                    return null;
                  });
              }
              return null;
            }
            throw new Error('Failed to fetch inventory levels: ' + response.status);
          }
          return response.json();
        }
        // Already parsed JSON
        return response;
      })
      .catch(function(error) {
        console.log('[Custom Availability Widget] App proxy and direct API failed:', error.message);
        // If both relative paths fail, try full backend URL if available
        if (fullBackendUrl) {
          console.log('[Custom Availability Widget] Trying full backend URL after error:', fullBackendUrl);
          return fetch(fullBackendUrl)
            .then(function(response) {
              if (!response.ok) {
                console.log('[Custom Availability Widget] Full backend URL failed:', response.status);
                return null;
              }
              return response.json();
            })
            .catch(function(e) {
              console.log('[Custom Availability Widget] Full backend URL error:', e.message);
              return null;
            });
        }
        // All methods failed
        console.log('[Custom Availability Widget] All backend API methods failed:', error.message);
        return null; // Return null instead of throwing to allow fallback
      })
      .then(function(data) {
        if (data && data.inventory_levels && Array.isArray(data.inventory_levels)) {
          console.log('[Custom Availability Widget] Got inventory levels from backend:', data.inventory_levels);
          var inventory = data.inventory_levels.map(function(level) {
            var locId = level.location_id || level.locationId;
            // Use quantity if available, otherwise use available field, default to 0
            var qty = level.quantity !== undefined ? level.quantity : (level.available !== undefined ? level.available : 0);
            var locName = locationIdToDetails[locId] ? locationIdToDetails[locId].name : (level.location_name || level.locationName || 'Location ' + locId);
            return {
              locationId: locId,
              locationName: locName,
              quantity: qty,
              available: qty > 0
            };
          });
          console.log('[Custom Availability Widget] ===== INVENTORY FROM BACKEND =====');
          inventory.forEach(function(loc) {
            console.log('[Custom Availability Widget]', loc.locationName, '(ID:', loc.locationId, ') - Qty:', loc.quantity, 'Available:', loc.available);
          });
          console.log('[Custom Availability Widget] =================================');
          // Return the data object with inventory_levels array for consistency
          return {
            inventory_levels: inventory
          };
        }
        return null;
      })
      .catch(function(error) {
        // Endpoint doesn't exist, that's fine - we'll use other methods
        console.log('[Custom Availability Widget] Backend inventory endpoint not available:', error.message);
        return null;
      });
  }

  /**
   * Create the widget HTML structure
   */
  function createWidgetHTML() {
    var widget = document.createElement('div');
    widget.id = 'custom-availability-widget';
    widget.className = 'custom-availability-widget';
    widget.innerHTML = `
      <div class="custom-availability-header">
        <label class="custom-availability-title">Availability</label>
      </div>
      <div class="custom-availability-content">
        <div class="custom-availability-loading" style="display: none;">
          <span>Loading availability...</span>
        </div>
        <div class="custom-availability-info">
          <!-- Content will be populated dynamically -->
        </div>
      </div>
    `;
    return widget;
  }

  /**
   * Render availability information based on shipping method
   */
  function renderAvailability() {
    // Prevent concurrent renders
    if (isRendering) {
      console.log('[Custom Availability Widget] Already rendering, skipping...');
      return;
    }
    
    // Get current state to check if anything actually changed
    var variantId = getCurrentVariantId();
    var currentMethod = getCurrentMethod();
    var selectedLocationId = getSelectedLocationId();
    var currentParams = variantId + '|' + currentMethod + '|' + selectedLocationId;
    
    // Check if this is a duplicate render with same parameters
    if (currentParams === lastRenderParams) {
      console.log('[Custom Availability Widget] Duplicate render request with same parameters, skipping...');
      return;
    }
    
    // Debounce rapid calls
    var now = Date.now();
    if (now - lastRenderTime < RENDER_DEBOUNCE_MS) {
      console.log('[Custom Availability Widget] Render debounced, scheduling delayed render...');
      if (renderDebounceTimer) {
        clearTimeout(renderDebounceTimer);
      }
      renderDebounceTimer = setTimeout(function() {
        renderDebounceTimer = null;
        renderAvailability();
      }, RENDER_DEBOUNCE_MS - (now - lastRenderTime));
      return;
    }
    
    // Detect potential infinite loop (more than 10 renders in 5 seconds)
    renderCallCount++;
    if (renderCallCount > 10) {
      console.error('[Custom Availability Widget] Potential infinite loop detected! Stopping renders.');
      setTimeout(function() {
        renderCallCount = 0; // Reset after 5 seconds
      }, 5000);
      return;
    }
    
    isRendering = true;
    lastRenderTime = now;
    lastRenderParams = currentParams; // Store current params
    
    if (!widgetContainer) {
      console.warn('[Custom Availability Widget] Widget container not found, attempting to initialize...');
      initWidget();
      if (!widgetContainer) {
        console.error('[Custom Availability Widget] Failed to initialize widget');
        isRendering = false;
        return;
      }
    }
    
    var contentArea = widgetContainer.querySelector('.custom-availability-info');
    var loadingArea = widgetContainer.querySelector('.custom-availability-loading');
    
    if (!contentArea) {
      console.error('[Custom Availability Widget] Content area not found');
      isRendering = false;
      return;
    }
    
    // Already got these above, reuse them
    // var currentMethod = getCurrentMethod();
    // var selectedLocationId = getSelectedLocationId();
    
    console.log('[Custom Availability Widget] Rendering - Method:', currentMethod, 'Location ID:', selectedLocationId, 'Variant:', variantId);
    
    // Show loading state
    if (loadingArea) loadingArea.style.display = 'block';
    contentArea.innerHTML = '';
    
    // Fetch inventory if we have a variant
    var variantId = getCurrentVariantId();
    if (!variantId) {
      if (loadingArea) loadingArea.style.display = 'none';
      contentArea.innerHTML = '<div class="custom-availability-message">Select a variant to see availability</div>';
      isRendering = false;
      return;
    }
    
    // If variant changed, fetch new inventory
    if (variantId !== currentVariantId) {
      currentVariantId = variantId;
      inventoryData = null;
    }
    
    // Fetch inventory data
    var fetchPromise = inventoryData 
      ? Promise.resolve(inventoryData)
      : fetchVariantInventory(variantId).then(function(data) {
          inventoryData = data;
          return data;
        });
    
    fetchPromise.then(function(inventory) {
      if (loadingArea) loadingArea.style.display = 'none';
      
      if (!inventory) {
        contentArea.innerHTML = '<div class="custom-availability-message">Unable to load availability</div>';
        isRendering = false;
        return;
      }
      
      var html = '';
      
      console.log('[Custom Availability Widget] Current method:', currentMethod, 'Selected location:', selectedLocationId);
      
      if (currentMethod === 'shipping') {
        // Shipping mode: Show aggregated inventory from all locations
        html = renderShippingAvailability(inventory);
      } else {
        // Local delivery or pickup: Show all locations with their availability
        html = renderLocationAvailability(inventory, selectedLocationId);
      }
      
      contentArea.innerHTML = html;
      isRendering = false; // Reset flag after successful render
    }).catch(function(error) {
      console.error('[Custom Availability Widget] Error rendering availability:', error);
      if (loadingArea) loadingArea.style.display = 'none';
      contentArea.innerHTML = '<div class="custom-availability-message">Error loading availability</div>';
      isRendering = false; // Reset flag after error
    });
  }

  /**
   * Fetch aggregated inventory from all locations
   */
  function fetchAggregatedInventory(variantId) {
    console.log('[Custom Availability Widget] fetchAggregatedInventory called for variant:', variantId);
    
    // Try backend API first to get per-location inventory
    return fetchInventoryLevelsFromBackend(variantId)
      .then(function(backendResult) {
        if (backendResult && backendResult.inventory_levels && Array.isArray(backendResult.inventory_levels) && backendResult.inventory_levels.length > 0) {
          console.log('[Custom Availability Widget] Got inventory from backend for aggregated:', backendResult.inventory_levels.length, 'locations');
          // Sum up quantities from all locations
          var totalQuantity = 0;
          var hasInventory = false;
          
          backendResult.inventory_levels.forEach(function(level) {
            var qty = level.quantity || level.available || 0;
            if (qty > 0) {
              hasInventory = true;
            }
            totalQuantity += qty;
          });
          
          console.log('[Custom Availability Widget] Aggregated total quantity:', totalQuantity);
          return {
            totalQuantity: totalQuantity,
            hasInventory: hasInventory,
            available: totalQuantity > 0 || hasInventory
          };
        }
        
        // Backend API didn't return data, try Multi-Location App API
        console.log('[Custom Availability Widget] Backend API returned no data, trying app API...');
        if (window.inventoryInfo && window.inventoryInfo.api) {
          // Try getProductInventory which should return all locations
          if (window.inventoryInfo.api.getProductInventory && typeof window.inventoryInfo.api.getProductInventory === 'function') {
            return window.inventoryInfo.api.getProductInventory(variantId)
              .then(function(result) {
                if (result && result.locations) {
                  // Sum up quantities from all locations
                  var totalQuantity = 0;
                  var hasInventory = false;
                  
                  result.locations.forEach(function(loc) {
                    var qty = loc.quantity || loc.available || 0;
                    if (qty > 0) {
                      hasInventory = true;
                    }
                    totalQuantity += qty;
                  });
                  
                  return {
                    totalQuantity: totalQuantity,
                    hasInventory: hasInventory,
                    available: totalQuantity > 0 || hasInventory
                  };
                }
                return null;
              })
              .catch(function(error) {
                console.warn('[Custom Availability Widget] Error fetching aggregated inventory from app:', error);
                return null;
              });
          }
          
          // Fallback: Try to get inventory for each location individually
          if (window.inventoryInfo.locationSettings && window.inventoryInfo.locationSettings.details) {
            var locationIds = window.inventoryInfo.locationSettings.details.map(function(loc) {
              return loc.id;
            });
            
            var fetchPromises = locationIds.map(function(locId) {
              if (window.inventoryInfo.api.getVariantAvailability && typeof window.inventoryInfo.api.getVariantAvailability === 'function') {
                return window.inventoryInfo.api.getVariantAvailability(variantId, locId)
                  .then(function(result) {
                    return result && result.quantity ? result.quantity : 0;
                  })
                  .catch(function() {
                    return 0;
                  });
              }
              return Promise.resolve(0);
            });
            
            return Promise.all(fetchPromises).then(function(quantities) {
              var totalQuantity = quantities.reduce(function(sum, qty) {
                return sum + (qty || 0);
              }, 0);
              
              return {
                totalQuantity: totalQuantity,
                hasInventory: totalQuantity > 0,
                available: totalQuantity > 0
              };
            }).catch(function(error) {
              console.warn('[Custom Availability Widget] Error fetching location inventories:', error);
              return null;
            });
          }
        }
        
        // No data from any source, return null to use fallback
        console.warn('[Custom Availability Widget] No inventory data available from any source');
        return null;
      })
      .catch(function(error) {
        console.warn('[Custom Availability Widget] Error in fetchAggregatedInventory:', error);
        return null;
      });
  }

  /**
   * Render availability for shipping mode (aggregated)
   */
  function renderShippingAvailability(inventory) {
    console.log('[Custom Availability Widget] ===== RENDER SHIPPING AVAILABILITY =====');
    console.log('[Custom Availability Widget] Inventory data:', inventory);
    
    var html = '<div class="custom-availability-shipping">';
    var variantId = getCurrentVariantId();
    console.log('[Custom Availability Widget] Variant ID for shipping:', variantId);
    
    // Try to fetch aggregated inventory from all locations
    if (variantId) {
      console.log('[Custom Availability Widget] Calling fetchAggregatedInventory...');
      fetchAggregatedInventory(variantId).then(function(aggregated) {
        console.log('[Custom Availability Widget] fetchAggregatedInventory returned:', aggregated);
        var contentArea = widgetContainer.querySelector('.custom-availability-info');
        if (!contentArea) return;
        
        var shippingHtml = '<div class="custom-availability-shipping">';
        
        if (aggregated && aggregated.totalQuantity !== undefined) {
          // Use aggregated inventory
          if (aggregated.totalQuantity > 0) {
            shippingHtml += '<div class="custom-availability-status in-stock">';
            shippingHtml += '<span class="custom-availability-label">Online Warehouse</span>';
            shippingHtml += '<span class="custom-availability-qty"><strong>' + aggregated.totalQuantity + ' available</strong></span>';
            shippingHtml += '</div>';
          } else {
            shippingHtml += '<div class="custom-availability-status out-of-stock">';
            shippingHtml += '<span class="custom-availability-label">Online Warehouse</span>';
            shippingHtml += '<span class="custom-availability-qty"><strong>Out of stock</strong></span>';
            shippingHtml += '</div>';
          }
        } else {
          // Fallback to general inventory
          if (inventory.inventoryManagement === 'shopify' && inventory.inventoryQuantity !== null) {
            if (inventory.inventoryQuantity > 0) {
              shippingHtml += '<div class="custom-availability-status in-stock">';
              shippingHtml += '<span class="custom-availability-label">Online Warehouse</span>';
              shippingHtml += '<span class="custom-availability-qty"><strong>' + inventory.inventoryQuantity + ' available</strong></span>';
              shippingHtml += '</div>';
            } else {
              shippingHtml += '<div class="custom-availability-status out-of-stock">';
              shippingHtml += '<span class="custom-availability-label">Online Warehouse</span>';
              shippingHtml += '<span class="custom-availability-qty"><strong>Out of stock</strong></span>';
              shippingHtml += '</div>';
            }
          } else {
            if (inventory.available) {
              shippingHtml += '<div class="custom-availability-status in-stock">';
              shippingHtml += '<span class="custom-availability-label">Online Warehouse</span>';
              shippingHtml += '<span class="custom-availability-qty"><strong>In stock</strong></span>';
              shippingHtml += '</div>';
            } else {
              shippingHtml += '<div class="custom-availability-status out-of-stock">';
              shippingHtml += '<span class="custom-availability-label">Online Warehouse</span>';
              shippingHtml += '<span class="custom-availability-qty"><strong>Out of stock</strong></span>';
              shippingHtml += '</div>';
            }
          }
        }
        
        shippingHtml += '</div>';
        console.log('[Custom Availability Widget] Updating content area with shipping HTML');
        contentArea.innerHTML = shippingHtml;
        console.log('[Custom Availability Widget] ===== SHIPPING AVAILABILITY RENDERED =====');
      }).catch(function(error) {
        console.error('[Custom Availability Widget] Error in fetchAggregatedInventory promise:', error);
        console.error('[Custom Availability Widget] Error stack:', error.stack);
      });
    } else {
      console.warn('[Custom Availability Widget] No variantId available for fetchAggregatedInventory');
    }
    
    // Show initial state while fetching
    if (inventory.inventoryManagement === 'shopify' && inventory.inventoryQuantity !== null) {
      if (inventory.inventoryQuantity > 0) {
        html += '<div class="custom-availability-status in-stock">';
        html += '<span class="custom-availability-label">Online Warehouse</span>';
        html += '<span class="custom-availability-qty"><strong>' + inventory.inventoryQuantity + ' available</strong></span>';
        html += '</div>';
      } else {
        html += '<div class="custom-availability-status out-of-stock">';
        html += '<span class="custom-availability-label">Online Warehouse</span>';
        html += '<span class="custom-availability-qty">Out of stock</span>';
        html += '</div>';
      }
    } else {
      if (inventory.available) {
        html += '<div class="custom-availability-status in-stock">';
        html += '<span class="custom-availability-label">Online Warehouse</span>';
        html += '<span class="custom-availability-qty"><strong>In stock</strong></span>';
        html += '</div>';
      } else {
        html += '<div class="custom-availability-status out-of-stock">';
        html += '<span class="custom-availability-label">Online Warehouse</span>';
        html += '<span class="custom-availability-qty">Out of stock</span>';
        html += '</div>';
      }
    }
    
    html += '</div>';
    return html;
  }

  /**
   * Fetch location-specific inventory from Multi-Location App API
   */
  function fetchLocationInventory(variantId, locationId) {
    if (!window.inventoryInfo || !window.inventoryInfo.api) {
      return Promise.resolve(null);
    }
    
    // Try to use the Multi-Location App's API
    if (window.inventoryInfo.api.getVariantAvailability) {
      return window.inventoryInfo.api.getVariantAvailability(variantId, locationId)
        .then(function(result) {
          return result;
        })
        .catch(function(error) {
          console.warn('[Custom Availability Widget] Error fetching location inventory from app:', error);
          return null;
        });
    }
    
    // Fallback: Try getProductInventory
    if (window.inventoryInfo.api.getProductInventory) {
      return window.inventoryInfo.api.getProductInventory(variantId)
        .then(function(result) {
          // Extract quantity for specific location
          if (result && result.locations) {
            var locationData = result.locations.find(function(loc) {
              return loc.id === locationId || loc.locationId === locationId;
            });
            if (locationData) {
              return {
                quantity: locationData.quantity || locationData.available || 0,
                available: (locationData.quantity || locationData.available || 0) > 0
              };
            }
          }
          return null;
        })
        .catch(function(error) {
          console.warn('[Custom Availability Widget] Error fetching product inventory:', error);
          return null;
        });
    }
    
    return Promise.resolve(null);
  }

  /**
   * Fetch inventory for all locations
   */
  function fetchAllLocationsInventory(variantId) {
    console.log('[Custom Availability Widget] fetchAllLocationsInventory called with variantId:', variantId);
    
    if (!variantId) {
      console.warn('[Custom Availability Widget] No variantId provided');
      return Promise.resolve([]);
    }
    
    // Always try backend API first, even if inventoryInfo.api doesn't exist
    console.log('[Custom Availability Widget] window.inventoryInfo:', window.inventoryInfo ? 'exists' : 'missing');
    console.log('[Custom Availability Widget] window.inventoryInfo.api:', window.inventoryInfo && window.inventoryInfo.api ? 'exists' : 'missing');
    
    // Try backend API first regardless of inventoryInfo
    console.log('[Custom Availability Widget] Attempting to fetch from backend API...');
    return fetchInventoryLevelsFromBackend(variantId)
      .then(function(backendResult) {
        console.log('[Custom Availability Widget] Backend API response:', backendResult);
        if (backendResult && backendResult.inventory_levels && Array.isArray(backendResult.inventory_levels) && backendResult.inventory_levels.length > 0) {
          console.log('[Custom Availability Widget] ✓✓✓ SUCCESS: Got', backendResult.inventory_levels.length, 'locations from backend!');
          var locationInventory = backendResult.inventory_levels.map(function(level) {
            // Support both locationId and location_id, quantity and available fields
            var locId = level.locationId || level.location_id;
            var qty = level.quantity !== undefined ? level.quantity : (level.available !== undefined ? level.available : 0);
            console.log('[Custom Availability Widget]   Location', locId, '- quantity:', qty, '- available:', qty > 0);
            return {
              locationId: locId,
              quantity: qty,
              available: qty > 0
            };
          });
          console.log('[Custom Availability Widget] ===== Returning', locationInventory.length, 'locations =====');
          return Promise.resolve(locationInventory);
        }
        
        console.log('[Custom Availability Widget] Backend API returned no data, trying fallback methods...');
        
        // Get location IDs for fallback methods
        var locationIds = [];
        if (window.inventoryInfo && window.inventoryInfo.locationSettings && window.inventoryInfo.locationSettings.details) {
          locationIds = window.inventoryInfo.locationSettings.details.map(function(loc) {
            return loc.id;
          });
          console.log('[Custom Availability Widget] Found location IDs for fallback:', locationIds);
        }
        
        // Backend API didn't return data, try Shopify variant API for general inventory
        console.log('[Custom Availability Widget] Trying Shopify variant API...');
        return fetchVariantInventory(variantId)
          .then(function(variantData) {
            if (variantData && (variantData.inventory || variantData.inventoryQuantity !== undefined)) {
              // We have general inventory, but not per-location
              // Return locations with the general quantity as estimate
              var generalQty = variantData.inventoryQuantity !== undefined ? variantData.inventoryQuantity : (variantData.inventory.inventoryQuantity || 0);
              var locationInventory = locationIds.map(function(locId) {
                return {
                  locationId: locId,
                  quantity: generalQty, // Use general quantity as estimate
                  available: generalQty > 0
                };
              });
              console.log('[Custom Availability Widget] Using general inventory quantity (', generalQty, ') for all locations');
              return Promise.resolve(locationInventory);
            }
            
            // No inventory data found anywhere, try DOM extraction
            console.log('[Custom Availability Widget] No inventory data found, trying DOM extraction...');
            return fetchFromDOM(variantId, locationIds);
          });
      })
      .catch(function(error) {
        console.warn('[Custom Availability Widget] Error fetching from backend:', error);
        // Fallback to variant API
        var locationIds = [];
        if (window.inventoryInfo && window.inventoryInfo.locationSettings && window.inventoryInfo.locationSettings.details) {
          locationIds = window.inventoryInfo.locationSettings.details.map(function(loc) {
            return loc.id;
          });
        }
        return fetchVariantInventory(variantId)
          .then(function(variantData) {
            if (variantData && (variantData.inventory || variantData.inventoryQuantity !== undefined)) {
              var generalQty = variantData.inventoryQuantity !== undefined ? variantData.inventoryQuantity : (variantData.inventory.inventoryQuantity || 0);
              var locationInventory = locationIds.map(function(locId) {
                return {
                  locationId: locId,
                  quantity: generalQty,
                  available: generalQty > 0
                };
              });
              return Promise.resolve(locationInventory);
            }
            return fetchFromDOM(variantId, locationIds);
          })
          .catch(function(error2) {
            console.warn('[Custom Availability Widget] Error fetching variant inventory:', error2);
            return fetchFromDOM(variantId, locationIds);
          });
      });
  }
  
  /**
   * Helper function to fetch inventory from DOM
   */
  function fetchFromDOM(variantId, locationIds) {
    console.log('[Custom Availability Widget] fetchFromDOM called but disabled to prevent stale quantities.');
    return Promise.resolve([]);
    // DISABLED: getWidgetHtml API causes "Cannot read properties of undefined (reading 'settings')" error
    // Try to use getWidgetHtml to get the widget HTML and parse it FIRST (before waiting for DOM)
    // if (window.inventoryInfo.api && typeof window.inventoryInfo.api.getWidgetHtml === 'function') {
    //   console.log('[Custom Availability Widget] Trying getWidgetHtml API...');
    //   try {
    //     var widgetHtml = window.inventoryInfo.api.getWidgetHtml();
    //     if (widgetHtml) {
    //       console.log('[Custom Availability Widget] Got widget HTML, parsing...');
    //       var tempDiv = document.createElement('div');
    //       tempDiv.innerHTML = widgetHtml;
    //       var listItems = tempDiv.querySelectorAll('.iia-list-item');
    //       if (listItems.length > 0) {
    //         console.log('[Custom Availability Widget] Found', listItems.length, 'items in widget HTML');
    //         var parsedInventory = [];
    //         listItems.forEach(function(item) {
    //           var locIdMatch = item.className.match(/iia-id-(\d+)/);
    //           if (locIdMatch) {
    //             var locId = parseInt(locIdMatch[1], 10);
    //             var qtyText = item.querySelector('.iia-qty');
    //             var locNameText = item.querySelector('.iia-location');
    //             var quantity = 0;
    //             var available = false;
    //             var locationName = locNameText ? locNameText.textContent.trim() : 'Location ' + locId;
    //             
    //             if (qtyText) {
    //               var qtyMatch = qtyText.textContent.match(/(\d+)\s+available/);
    //               if (qtyMatch) {
    //                 quantity = parseInt(qtyMatch[1], 10);
    //                 available = quantity > 0;
    //               } else if (qtyText.textContent.toLowerCase().indexOf('out of stock') === -1) {
    //                 available = true;
    //                 quantity = 1;
    //               }
    //             }
    //             
    //             parsedInventory.push({
    //               locationId: locId,
    //               locationName: locationName,
    //               quantity: quantity,
    //               available: available
    //             });
    //           }
    //         });
    //         
    //         if (parsedInventory.length > 0) {
    //           console.log('[Custom Availability Widget] ===== PARSED INVENTORY FROM getWidgetHtml =====');
    //           parsedInventory.forEach(function(loc) {
    //             console.log('[Custom Availability Widget]', loc.locationName, '(ID:', loc.locationId, ') - Qty:', loc.quantity, 'Available:', loc.available);
    //           });
    //           console.log('[Custom Availability Widget] ===========================================');
    //           return Promise.resolve(parsedInventory);
    //         }
    //       }
    //     }
    //   } catch(e) {
    //     console.warn('[Custom Availability Widget] Error using getWidgetHtml:', e);
    //   }
    // }
    
    // Try to extract inventory from the app's widget DOM if it's rendered
    // The app renders inventory in .iia-list-item elements
    console.log('[Custom Availability Widget] ===== CHECKING APP WIDGET DOM =====');
    var appWidget = document.querySelector('#inventory-info-app, .iia-container');
    if (appWidget) {
      console.log('[Custom Availability Widget] Found app widget:', appWidget.id || appWidget.className);
      
      // Try to trigger the app to load/display inventory if it hasn't already
      // The app might need variant tracking to be triggered
      // BUT: trackVariantChanges is causing errors, so we'll skip it for now
      // if (window.inventoryInfo && window.inventoryInfo.api && typeof window.inventoryInfo.api.trackVariantChanges === 'function') {
      //   console.log('[Custom Availability Widget] Triggering trackVariantChanges to load inventory...');
      //   try {
      //     // Check if settings exist before calling
      //     if (window.inventoryInfo.settings) {
      //       window.inventoryInfo.api.trackVariantChanges(variantId);
      //     } else {
      //       console.warn('[Custom Availability Widget] inventoryInfo.settings not available, skipping trackVariantChanges');
      //     }
      //   } catch(e) {
      //     console.warn('[Custom Availability Widget] Error calling trackVariantChanges:', e);
      //   }
      // }
      
      // Wait a bit for the widget to render, then check again
      return new Promise(function(resolve) {
        var attempts = 0;
        var maxAttempts = 10;
        var checkInterval = 200; // Check every 200ms
        
        var checkForItems = function() {
          attempts++;
          var listItems = appWidget.querySelectorAll('.iia-list-item');
          console.log('[Custom Availability Widget] Attempt', attempts, '- Found', listItems.length, 'location items in DOM');
          
          if (listItems.length > 0 || attempts >= maxAttempts) {
            if (listItems.length > 0) {
              console.log('[Custom Availability Widget] Extracting inventory from DOM...');
              var domInventory = [];
              listItems.forEach(function(item, index) {
                var locIdMatch = item.className.match(/iia-id-(\d+)/);
                if (locIdMatch) {
                  var locId = parseInt(locIdMatch[1], 10);
                  var qtyText = item.querySelector('.iia-qty');
                  var locNameText = item.querySelector('.iia-location');
                  var quantity = 0;
                  var available = false;
                  var locationName = locNameText ? locNameText.textContent.trim() : 'Location ' + locId;
                  var qtyTextContent = qtyText ? qtyText.textContent.trim() : '';
                  
                  console.log('[Custom Availability Widget] Item', index + 1, '- Location ID:', locId, 'Name:', locationName, 'Qty Text:', qtyTextContent);
                  
                  if (qtyText) {
                    var qtyMatch = qtyText.textContent.match(/(\d+)\s+available/);
                    if (qtyMatch) {
                      quantity = parseInt(qtyMatch[1], 10);
                      available = quantity > 0;
                      console.log('[Custom Availability Widget]   -> Parsed quantity:', quantity, 'Available:', available);
                    } else if (qtyText.textContent.toLowerCase().indexOf('out of stock') === -1 && 
                               qtyText.textContent.toLowerCase().indexOf('unavailable') === -1 &&
                               qtyText.textContent.toLowerCase().indexOf('sold out') === -1) {
                      // If it says "in stock" or similar without a number
                      available = true;
                      quantity = 1; // Unknown quantity but available
                      console.log('[Custom Availability Widget]   -> No quantity number, but appears available');
                    } else {
                      console.log('[Custom Availability Widget]   -> Out of stock');
                    }
                  } else {
                    console.log('[Custom Availability Widget]   -> No quantity text found');
                  }
                  
                  domInventory.push({
                    locationId: locId,
                    locationName: locationName,
                    quantity: quantity,
                    available: available
                  });
                } else {
                  console.log('[Custom Availability Widget] Item', index + 1, '- No location ID found in className:', item.className);
                }
              });
              
              if (domInventory.length > 0) {
                console.log('[Custom Availability Widget] ===== DOM INVENTORY EXTRACTED =====');
                domInventory.forEach(function(loc) {
                  console.log('[Custom Availability Widget]', loc.locationName, '(ID:', loc.locationId, ') - Qty:', loc.quantity, 'Available:', loc.available);
                });
                console.log('[Custom Availability Widget] ====================================');
                resolve(domInventory);
                return;
              }
            }
            
            // If we've exhausted attempts or got items but no data, return locations with unknown quantities
            if (attempts >= maxAttempts) {
              console.warn('[Custom Availability Widget] Widget did not render inventory after', maxAttempts, 'attempts');
              // Return locations with unknown quantities instead of empty array
              if (locationIds && locationIds.length > 0) {
                var locationsWithUnknownQty = locationIds.map(function(locId) {
                  return {
                    locationId: locId,
                    quantity: null // null means unknown/checking
                  };
                });
                console.log('[Custom Availability Widget] Returning', locationsWithUnknownQty.length, 'locations with unknown quantities (DOM extraction failed)');
                resolve(locationsWithUnknownQty);
                return;
              }
            }
            resolve([]); // Only return empty if no locationIds available
          } else {
            // Check again after delay
            setTimeout(checkForItems, checkInterval);
          }
        };
        
        // Start checking
        checkForItems();
      });
    } else {
      console.log('[Custom Availability Widget] App widget not found in DOM');
      // Return locations with unknown quantities instead of empty array
      if (locationIds && locationIds.length > 0) {
        var locationsWithUnknownQty = locationIds.map(function(locId) {
          return {
            locationId: locId,
            quantity: null // null means unknown/checking
          };
        });
        console.log('[Custom Availability Widget] Returning', locationsWithUnknownQty.length, 'locations with unknown quantities (no widget DOM)');
        return Promise.resolve(locationsWithUnknownQty);
      }
      return Promise.resolve([]);
    }
    
    // Try to use getProductInventory which returns all locations at once
    if (window.inventoryInfo.api && typeof window.inventoryInfo.api.getProductInventory === 'function') {
      console.log('[Custom Availability Widget] Using getProductInventory API');
      return window.inventoryInfo.api.getProductInventory(variantId)
        .then(function(result) {
          console.log('[Custom Availability Widget] getProductInventory result:', result);
          if (result && result.locations && Array.isArray(result.locations)) {
            var locationsData = result.locations.map(function(loc) {
              return {
                locationId: loc.id || loc.locationId,
                quantity: loc.quantity || loc.available || 0,
                available: (loc.quantity || loc.available || 0) > 0
              };
            });
            console.log('[Custom Availability Widget] Processed locations data:', locationsData);
            return locationsData;
          }
          console.warn('[Custom Availability Widget] getProductInventory returned invalid data structure');
          return [];
        })
        .catch(function(error) {
          console.error('[Custom Availability Widget] Error fetching all locations inventory:', error);
          return [];
        });
    }
    
    // Fallback: Fetch each location individually
    if (window.inventoryInfo.api && typeof window.inventoryInfo.api.getVariantAvailability === 'function') {
      console.log('[Custom Availability Widget] ===== USING getVariantAvailability API (fallback) =====');
      console.log('[Custom Availability Widget] Fetching inventory for', locationIds.length, 'locations individually...');
      var fetchPromises = locationIds.map(function(locId) {
        var locationName = locationIdToDetails[locId] ? locationIdToDetails[locId].name : 'Location ' + locId;
        console.log('[Custom Availability Widget] Fetching location:', locationName, '(ID:', locId, ')...');
        
        return window.inventoryInfo.api.getVariantAvailability(variantId, locId)
          .then(function(result) {
            var qty = result && result.quantity !== undefined ? result.quantity : (result && result.available ? 1 : 0);
            var isAvailable = result && result.quantity ? result.quantity > 0 : (result && result.available ? true : false);
            
            console.log('[Custom Availability Widget]   Location:', locationName, '(ID:', locId, ') - Result:', result, 'Qty:', qty, 'Available:', isAvailable);
            
            return {
              locationId: locId,
              locationName: locationName,
              quantity: qty,
              available: isAvailable
            };
          })
          .catch(function(error) {
            console.warn('[Custom Availability Widget]   Location:', locationName, '(ID:', locId, ') - Error:', error);
            return {
              locationId: locId,
              locationName: locationName,
              quantity: 0,
              available: false
            };
          });
      });
      
      return Promise.all(fetchPromises).then(function(results) {
        console.log('[Custom Availability Widget] ===== ALL LOCATION RESULTS =====');
        results.forEach(function(loc) {
          console.log('[Custom Availability Widget]', loc.locationName, '(ID:', loc.locationId, ') - Qty:', loc.quantity, 'Available:', loc.available);
        });
        console.log('[Custom Availability Widget] ================================');
        return results;
      });
    }
    
    // Final fallback: Deep inspect inventoryInfo for any inventory data
    console.log('[Custom Availability Widget] ===== DEEP INSPECTING APP STATE =====');
    
    // Function to recursively search for inventory data
    function findInventoryData(obj, path, visited) {
      if (!visited) visited = new Set();
      if (visited.has(obj)) return null; // Prevent circular references
      visited.add(obj);
      
      if (!obj || typeof obj !== 'object') return null;
      
      // Check if this object looks like inventory data
      if (Array.isArray(obj)) {
        if (obj.length > 0 && obj[0] && typeof obj[0] === 'object') {
          var first = obj[0];
          if (first.location_id || first.locationId || first.id) {
            // This looks like location inventory array
            console.log('[Custom Availability Widget] Found potential inventory array at', path);
            var inventory = obj.map(function(item) {
              var locId = item.location_id || item.locationId || item.id;
              var qty = item.quantity || item.available || item.inventory || item.qty || 0;
              var locName = locationIdToDetails[locId] ? locationIdToDetails[locId].name : 'Location ' + locId;
              return {
                locationId: locId,
                locationName: locName,
                quantity: qty,
                available: qty > 0
              };
            }).filter(function(item) {
              return locationIds.indexOf(item.locationId) !== -1; // Only include known locations
            });
            
            if (inventory.length > 0) {
              console.log('[Custom Availability Widget] ===== EXTRACTED INVENTORY FROM', path, '=====');
              inventory.forEach(function(loc) {
                console.log('[Custom Availability Widget]', loc.locationName, '(ID:', loc.locationId, ') - Qty:', loc.quantity, 'Available:', loc.available);
              });
              console.log('[Custom Availability Widget] ===========================================');
              return inventory;
            }
          }
        }
      } else {
        // Check object properties
        Object.keys(obj).forEach(function(key) {
          if (key.toLowerCase().indexOf('inventory') !== -1 || 
              key.toLowerCase().indexOf('quantity') !== -1 ||
              key.toLowerCase().indexOf('stock') !== -1 ||
              key.toLowerCase().indexOf('available') !== -1) {
            var newPath = path ? path + '.' + key : key;
            var result = findInventoryData(obj[key], newPath, visited);
            if (result) return result;
          }
        });
      }
      
      return null;
    }
    
    // Search inventoryInfo for inventory data
    var foundInventory = findInventoryData(window.inventoryInfo, 'inventoryInfo', new Set());
    if (foundInventory && foundInventory.length > 0) {
      return Promise.resolve(foundInventory);
    }
    
    // Also check if there's a variant-specific inventory object
    if (window.inventoryInfo && window.inventoryInfo[variantId]) {
      console.log('[Custom Availability Widget] Found variant-specific data at inventoryInfo[' + variantId + ']');
      var variantData = window.inventoryInfo[variantId];
      var variantInventory = findInventoryData(variantData, 'inventoryInfo[' + variantId + ']', new Set());
      if (variantInventory && variantInventory.length > 0) {
        return Promise.resolve(variantInventory);
      }
    }
    
    console.log('[Custom Availability Widget] =========================================');
    console.log('[Custom Availability Widget] No inventory data found from any method');
    
    // Return locations with unknown quantities instead of empty array
    // This allows the widget to still display all locations
    if (window.inventoryInfo && window.inventoryInfo.locationSettings && window.inventoryInfo.locationSettings.details) {
      var locationIds = window.inventoryInfo.locationSettings.details.map(function(loc) {
        return loc.id;
      });
      
      var locationsWithUnknownQty = locationIds.map(function(locId) {
        return {
          locationId: locId,
          quantity: null // null means unknown/checking
        };
      });
      
      console.log('[Custom Availability Widget] Returning', locationsWithUnknownQty.length, 'locations with unknown quantities');
      return Promise.resolve(locationsWithUnknownQty);
    }
    
    console.log('[Custom Availability Widget] No location settings available, returning empty array');
    return Promise.resolve([]);
  }

  /**
   * Render availability for local delivery/pickup (all locations)
   */
  function renderLocationAvailability(inventory, selectedLocationId) {
    var html = '<div class="custom-availability-locations">';
    var variantId = getCurrentVariantId();
    
    // Show loading state
    html += '<div class="custom-availability-message">Loading location availability...</div>';
    html += '</div>';
    
    // Fetch inventory for all locations
    // Always try to fetch from backend API, even if inventoryInfo.api doesn't exist
    console.log('[Custom Availability Widget] renderLocationAvailability - variantId:', variantId);
    console.log('[Custom Availability Widget] window.inventoryInfo:', window.inventoryInfo ? 'exists' : 'missing');
    console.log('[Custom Availability Widget] window.inventoryInfo.api:', window.inventoryInfo && window.inventoryInfo.api ? 'exists' : 'missing');
    
    if (variantId) {
      fetchAllLocationsInventory(variantId).then(function(locationsData) {
        console.log('[Custom Availability Widget] fetchAllLocationsInventory returned:', locationsData);
        var contentArea = widgetContainer.querySelector('.custom-availability-info');
        if (!contentArea) {
          console.warn('[Custom Availability Widget] Content area not found');
          return;
        }
        
        var locationsHtml = '<div class="custom-availability-locations">';
        
        if (locationsData && locationsData.length > 0) {
          console.log('[Custom Availability Widget] Processing', locationsData.length, 'locations');
          console.log('[Custom Availability Widget] Selected location ID:', selectedLocationId);
          
          // Sort locations - put selected location first, then sort the rest alphabetically
          var sortedLocations = locationsData.slice().sort(function(a, b) {
            // Normalize location IDs for comparison (handle both string and number)
            var aId = typeof a.locationId === 'string' ? parseInt(a.locationId, 10) : a.locationId;
            var bId = typeof b.locationId === 'string' ? parseInt(b.locationId, 10) : b.locationId;
            var selectedId = typeof selectedLocationId === 'string' ? parseInt(selectedLocationId, 10) : selectedLocationId;
            
            var aIsSelected = selectedId && aId === selectedId;
            var bIsSelected = selectedId && bId === selectedId;
            
            // Selected location always comes first
            if (aIsSelected && !bIsSelected) return -1;
            if (!aIsSelected && bIsSelected) return 1;
            
            // If both are selected or neither is selected, sort alphabetically by name
            var aName = (a.locationName || '').toLowerCase();
            var bName = (b.locationName || '').toLowerCase();
            if (aName < bName) return -1;
            if (aName > bName) return 1;
            return 0;
          });
          
          sortedLocations.forEach(function(locData) {
            console.log('[Custom Availability Widget] Processing location:', locData.locationId, 'quantity:', locData.quantity);
            var location = locationIdToDetails[locData.locationId];
            if (!location) {
              console.warn('[Custom Availability Widget] Location not found in locationIdToDetails:', locData.locationId);
              // Don't skip - use the location data from the API instead
              location = {
                id: locData.locationId,
                name: locData.locationName || 'Location ' + locData.locationId
              };
            }
            
            var isSelected = selectedLocationId && locData.locationId === selectedLocationId;
            var locationClass = isSelected ? 'custom-availability-location-item selected' : 'custom-availability-location-item';
            
            // Calculate distance if we have delivery coordinates and store coordinates
            var distanceText = '';
            var deliveryCoords = getDeliveryCoordinates();
            if (deliveryCoords && location.lat && location.lng) {
              var distance = calculateDistance(
                deliveryCoords.lat,
                deliveryCoords.lng,
                location.lat,
                location.lng
              );
              distanceText = '<span class="custom-availability-distance">' + distance.toFixed(1) + ' miles away</span>';
            }
            
            locationsHtml += '<div class="' + locationClass + '">';
            locationsHtml += '<div class="custom-availability-location-header">';
            locationsHtml += '<span class="custom-availability-location-name">' + escapeHtml(location.name) + '</span>';
            if (isSelected) {
              locationsHtml += ' <span class="custom-availability-selected-badge">(Selected)</span>';
            }
            if (distanceText) {
              locationsHtml += ' ' + distanceText;
            }
            locationsHtml += '</div>';
            
            if (locData.quantity !== undefined && locData.quantity !== null) {
              // We have a specific quantity for this location
              if (locData.quantity > 0) {
                locationsHtml += '<div class="custom-availability-status in-stock">';
                locationsHtml += '<span class="custom-availability-qty"><strong>' + locData.quantity + ' available</strong></span>';
                locationsHtml += '</div>';
              } else {
                locationsHtml += '<div class="custom-availability-status out-of-stock">';
                locationsHtml += '<span class="custom-availability-qty"><strong>Out of stock</strong></span>';
                locationsHtml += '</div>';
              }
            } else if (locData.quantity === null) {
              // Quantity is unknown (null) - show "Checking availability" or use general inventory
              if (inventory.inventoryManagement === 'shopify' && inventory.inventoryQuantity !== null) {
                if (inventory.inventoryQuantity > 0) {
                  locationsHtml += '<div class="custom-availability-status in-stock">';
                  locationsHtml += '<span class="custom-availability-qty">' + inventory.inventoryQuantity + ' available (estimated)</span>';
                  locationsHtml += '</div>';
                } else {
                  locationsHtml += '<div class="custom-availability-status out-of-stock">';
                  locationsHtml += '<span class="custom-availability-qty">Out of stock</span>';
                  locationsHtml += '</div>';
                }
              } else {
                // Show checking status
                locationsHtml += '<div class="custom-availability-status">';
                locationsHtml += '<span class="custom-availability-qty">Checking availability...</span>';
                locationsHtml += '</div>';
              }
            } else {
              // Fallback to general inventory (quantity is undefined)
              if (inventory.inventoryManagement === 'shopify' && inventory.inventoryQuantity !== null) {
                if (inventory.inventoryQuantity > 0) {
                  locationsHtml += '<div class="custom-availability-status in-stock">';
                  locationsHtml += '<span class="custom-availability-qty">' + inventory.inventoryQuantity + ' available</span>';
                  locationsHtml += '</div>';
                } else {
                  locationsHtml += '<div class="custom-availability-status out-of-stock">';
                  locationsHtml += '<span class="custom-availability-qty">Out of stock</span>';
                  locationsHtml += '</div>';
                }
              } else {
                if (inventory.available) {
                  locationsHtml += '<div class="custom-availability-status in-stock">';
                  locationsHtml += '<span class="custom-availability-qty">In stock</span>';
                  locationsHtml += '</div>';
                } else {
                  locationsHtml += '<div class="custom-availability-status out-of-stock">';
                  locationsHtml += '<span class="custom-availability-qty">Out of stock</span>';
                  locationsHtml += '</div>';
                }
              }
            }
            
            // Add address and phone info
            var addressParts = [];
            if (location.address1) {
              addressParts.push(escapeHtml(location.address1));
            }
            if (location.city) {
              addressParts.push(escapeHtml(location.city));
            }
            if (location.zip) {
              addressParts.push(escapeHtml(location.zip));
            }
            
            if (addressParts.length > 0 || location.phone) {
              locationsHtml += '<div class="custom-availability-location-address">';
              if (addressParts.length > 0) {
                locationsHtml += addressParts.join(', ');
              }
              if (location.phone) {
                if (addressParts.length > 0) {
                  locationsHtml += ' • ';
                }
                locationsHtml += '<span class="custom-availability-phone">' + escapeHtml(location.phone) + '</span>';
              }
              locationsHtml += '</div>';
            }
            
            locationsHtml += '</div>';
          });
        } else {
          // No location data available, show fallback with more info
          console.warn('[Custom Availability Widget] No location data returned from API');
          locationsHtml += '<div class="custom-availability-message">Loading location availability...</div>';
          
          // Try to show locations anyway using the locationIdToDetails mapping
          if (window.inventoryInfo && window.inventoryInfo.locationSettings && window.inventoryInfo.locationSettings.details) {
            var allLocationIds = window.inventoryInfo.locationSettings.details.map(function(loc) {
              return loc.id;
            });
            
            // Sort to put selected location first
            allLocationIds.sort(function(a, b) {
              var aIsSelected = selectedLocationId && a === selectedLocationId;
              var bIsSelected = selectedLocationId && b === selectedLocationId;
              if (aIsSelected && !bIsSelected) return -1;
              if (!aIsSelected && bIsSelected) return 1;
              return 0;
            });
            
            allLocationIds.forEach(function(locId) {
              var location = locationIdToDetails[locId];
              if (location) {
                // Calculate distance if we have delivery coordinates
                var distanceText = '';
                var deliveryCoords = getDeliveryCoordinates();
                if (deliveryCoords && location.lat && location.lng) {
                  var distance = calculateDistance(
                    deliveryCoords.lat,
                    deliveryCoords.lng,
                    location.lat,
                    location.lng
                  );
                  distanceText = '<span class="custom-availability-distance">' + distance.toFixed(1) + ' miles away</span>';
                }
                
                locationsHtml += '<div class="custom-availability-location-item">';
                locationsHtml += '<div class="custom-availability-location-header">';
                locationsHtml += '<span class="custom-availability-location-name">' + escapeHtml(location.name) + '</span>';
                if (selectedLocationId && locId === selectedLocationId) {
                  locationsHtml += ' <span class="custom-availability-selected-badge">(Selected)</span>';
                }
                if (distanceText) {
                  locationsHtml += ' ' + distanceText;
                }
                locationsHtml += '</div>';
                locationsHtml += '<div class="custom-availability-status">';
                locationsHtml += '<span class="custom-availability-qty">Checking availability...</span>';
                locationsHtml += '</div>';
                
                // Add address and phone info
                var addressParts = [];
                if (location.address1) {
                  addressParts.push(escapeHtml(location.address1));
                }
                if (location.city) {
                  addressParts.push(escapeHtml(location.city));
                }
                if (location.zip) {
                  addressParts.push(escapeHtml(location.zip));
                }
                
                if (addressParts.length > 0 || location.phone) {
                  locationsHtml += '<div class="custom-availability-location-address">';
                  if (addressParts.length > 0) {
                    locationsHtml += addressParts.join(', ');
                  }
                  if (location.phone) {
                    if (addressParts.length > 0) {
                      locationsHtml += ' • ';
                    }
                    locationsHtml += '<span class="custom-availability-phone">' + escapeHtml(location.phone) + '</span>';
                  }
                  locationsHtml += '</div>';
                }
                locationsHtml += '</div>';
              }
            });
          } else {
            locationsHtml += '<div class="custom-availability-message">Unable to load location availability</div>';
          }
        }
        
        locationsHtml += '</div>';
        contentArea.innerHTML = locationsHtml;
        console.log('[Custom Availability Widget] ===== LOCATION AVAILABILITY RENDERED =====');
        isRendering = false; // Reset flag after async render completes
      }).catch(function(error) {
        console.error('[Custom Availability Widget] Error rendering all locations availability:', error);
        var contentArea = widgetContainer.querySelector('.custom-availability-info');
        if (contentArea) {
          contentArea.innerHTML = '<div class="custom-availability-message">Error loading location availability</div>';
        }
        isRendering = false; // Reset flag after error
      });
    } else {
      // No API available, show message
      html = '<div class="custom-availability-locations">';
      html += '<div class="custom-availability-message">Location inventory data not available</div>';
      html += '</div>';
    }
    
    return html;
  }

  /**
   * Escape HTML to prevent XSS
   */
  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  /**
   * Initialize the widget
   */
  function initWidget() {
    if (isInitialized) return;
    
    // Only run on product pages
    if (!document.querySelector('.product_page_template')) {
      return;
    }
    
    // Find the right column where the widget should go
    var rightColumn = document.querySelector('.tt-product-single-aside');
    if (!rightColumn) {
      console.warn('[Custom Availability Widget] Right column not found');
      return;
    }
    
    // Check if widget already exists
    widgetContainer = document.getElementById('custom-availability-widget');
    if (!widgetContainer) {
      // Create widget
      widgetContainer = createWidgetHTML();
      rightColumn.appendChild(widgetContainer);
      console.log('[Custom Availability Widget] Widget created and added to page');
    } else {
      console.log('[Custom Availability Widget] Widget already exists');
    }
    
    // Listen for method changes (shipping/local delivery/pickup) from header selector
    var lastMethod = window.currentMethod;
    var methodCheckInterval = setInterval(function() {
      if (window.currentMethod && window.currentMethod !== lastMethod) {
        lastMethod = window.currentMethod;
        console.log('[Custom Availability Widget] Detected method change to:', window.currentMethod);
        // Save selection when method changes
        saveCurrentSelection();
        // Re-render widget when method changes to update selected location
        setTimeout(function() {
          if (window.customAvailabilityWidget && typeof window.customAvailabilityWidget.render === 'function') {
            window.customAvailabilityWidget.render();
          }
        }, 300);
      }
    }, 500);
    
    // Clean up interval when page unloads
    window.addEventListener('beforeunload', function() {
      if (methodCheckInterval) {
        clearInterval(methodCheckInterval);
      }
    });
    
    // Auto-select last selection before initial render
    autoSelectLastSelection();
    
    // Initial render
    console.log('[Custom Availability Widget] Initializing render...');
    renderAvailability();
    
    // Save selection periodically and on events
    setInterval(function() {
      saveCurrentSelection();
    }, 2000); // Save every 2 seconds
    
    // Listen for variant changes
    var variantSelectors = document.querySelectorAll('[name="id"], select[name*="variant"], input[name="id"][type="hidden"]');
    variantSelectors.forEach(function(selector) {
      selector.addEventListener('change', function() {
        inventoryData = null; // Reset to force refetch
        renderAvailability();
      });
    });
    
    // Listen for shipping method changes (events are dispatched on document)
    document.addEventListener('shippingMethodChanged', function() {
      inventoryData = null; // Reset to force refetch
      renderAvailability();
    });
    
    // Listen for location changes (events are dispatched on document)
    document.addEventListener('locationChanged', function() {
      console.log('[Custom Availability Widget] locationChanged event received');
      setTimeout(function() {
        renderAvailability();
      }, 200);
    });
    
    document.addEventListener('locationSelected', function() {
      console.log('[Custom Availability Widget] locationSelected event received');
      saveCurrentSelection(); // Save when location is selected
      // Small delay to let forcedLocationId be set
      setTimeout(function() {
        renderAvailability();
      }, 200);
    });
    
    document.addEventListener('inventoryInfo:locationChanged', function() {
      console.log('[Custom Availability Widget] inventoryInfo:locationChanged event received');
      saveCurrentSelection(); // Save when location changes
      setTimeout(function() {
        renderAvailability();
      }, 200);
    });
    
    // Monitor forcedLocationId changes
    var lastForcedLocationId = window.forcedLocationId;
    setInterval(function() {
      if (window.forcedLocationId && window.forcedLocationId !== lastForcedLocationId) {
        lastForcedLocationId = window.forcedLocationId;
        console.log('[Custom Availability Widget] Detected forcedLocationId change:', window.forcedLocationId);
        setTimeout(function() {
          renderAvailability();
        }, 100);
      }
    }, 500);
    
    // Also listen for custom events from header-location-selector
    document.addEventListener('DOMContentLoaded', function() {
      // Re-render when page fully loads
      setTimeout(renderAvailability, 500);
    });
    
    isInitialized = true;
  }

  // Expose render function globally IMMEDIATELY (before DOM ready)
  window.customAvailabilityWidget = {
    render: renderAvailability,
    init: initWidget
  };
  
  console.log('[Custom Availability Widget] Script loaded, widget API exposed');
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      console.log('[Custom Availability Widget] DOMContentLoaded fired, initializing...');
      initWidget();
    });
  } else {
    console.log('[Custom Availability Widget] DOM already ready, initializing immediately...');
    initWidget();
  }
  
  // Also try after delays to catch dynamic content
  setTimeout(function() {
    console.log('[Custom Availability Widget] Delayed init attempt 1 (500ms)');
    initWidget();
  }, 500);
  
  setTimeout(function() {
    console.log('[Custom Availability Widget] Delayed init attempt 2 (1000ms)');
    initWidget();
  }, 1000);
  
  setTimeout(function() {
    console.log('[Custom Availability Widget] Delayed init attempt 3 (2000ms)');
    initWidget();
  }, 2000);
  
  console.log('[Custom Availability Widget] IIFE completed, widget should be available');

})();

// Final check
try {
  if (window.customAvailabilityWidget) {
    console.log('[Custom Availability Widget] Widget API successfully exposed:', typeof window.customAvailabilityWidget.render);
  } else {
    console.error('[Custom Availability Widget] Widget API NOT exposed!');
  }
} catch(e) {
  console.error('[Custom Availability Widget] Error checking widget API:', e);
}

